'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardLoginsResponse(total, errors, rate, hosts, hostStats, systemStats, topUsers, topAccounts, sign) {
  this.xk = 0;
  this.DO = 0;
  this.DQ = 0.0;
  this.DP = null;
  this.xi = null;
  this.xj = null;
  this.DT = null;
  this.DS = null;
  this.DR = null;
  this.xk = total;
  this.DO = errors;
  this.DQ = rate;
  this.DP = hosts;
  this.xi = hostStats;
  this.xj = systemStats;
  this.DT = topUsers;
  this.DS = topAccounts;
  this.DR = sign;
}
export { $c_Lpresto_types$DashboardLoginsResponse as $c_Lpresto_types$DashboardLoginsResponse };
$p = $c_Lpresto_types$DashboardLoginsResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardLoginsResponse;
/** @constructor */
function $h_Lpresto_types$DashboardLoginsResponse() {
}
export { $h_Lpresto_types$DashboardLoginsResponse as $h_Lpresto_types$DashboardLoginsResponse };
$h_Lpresto_types$DashboardLoginsResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardLoginsResponse"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.xk);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.DO);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().gW(this.DQ));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DP));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xi));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.xj));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DT));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DS));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DR));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 9);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$DashboardLoginsResponse)) {
    if ((((this.xk === x$0.xk) && (this.DO === x$0.DO)) && (this.DQ === x$0.DQ))) {
      var x = this.DP;
      var x$2 = x$0.DP;
      var $x_5 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3 = this.xi;
      var x$4 = x$0.xi;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.xj;
      var x$6 = x$0.xj;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.DT;
      var x$8 = x$0.DT;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.DS;
      var x$10 = x$0.DS;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.DR;
      var x$12 = x$0.DR;
      return ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 9;
});
$p.s = (function() {
  return "DashboardLoginsResponse";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.xk;
      break;
    }
    case 1: {
      return this.DO;
      break;
    }
    case 2: {
      return this.DQ;
      break;
    }
    case 3: {
      return this.DP;
      break;
    }
    case 4: {
      return this.xi;
      break;
    }
    case 5: {
      return this.xj;
      break;
    }
    case 6: {
      return this.DT;
      break;
    }
    case 7: {
      return this.DS;
      break;
    }
    case 8: {
      return this.DR;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$DashboardLoginsResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jI)));
}
export { $isArrayOf_Lpresto_types$DashboardLoginsResponse as $isArrayOf_Lpresto_types$DashboardLoginsResponse };
var $d_Lpresto_types$DashboardLoginsResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardLoginsResponse, "presto.types$DashboardLoginsResponse", ({
  jI: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardLoginsResponse as $d_Lpresto_types$DashboardLoginsResponse };
//# sourceMappingURL=presto.types$-Dashboard-Logins-Response.js.map
